import { Droplets, FlaskConical, Scale } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from '../shared/ui/Button';
import { Modal } from '../shared/ui/Modal';
import { usePreferences } from './PreferencesContext';

interface WelcomeDialogProps {
  open: boolean;
  onDismiss: () => void;
}

export function WelcomeDialog({ open, onDismiss }: WelcomeDialogProps) {
  const { t } = useTranslation();
  const { locale, setLocale } = usePreferences();
  return (
    <Modal
      open={open}
      onOpenChange={(next) => !next && onDismiss()}
      title={t('app.welcomeTitle')}
      footer={
        <Button size="lg" onClick={onDismiss}>
          {t('app.understood')}
        </Button>
      }
    >
      <div className="welcome-language no-print">
        <Button
          size="sm"
          variant={locale === 'de' ? 'primary' : 'secondary'}
          onClick={() => setLocale('de')}
        >
          Deutsch
        </Button>
        <Button
          size="sm"
          variant={locale === 'ar' ? 'primary' : 'secondary'}
          onClick={() => setLocale('ar')}
        >
          العربية
        </Button>
      </div>
      <div className="welcome-list">
        <div>
          <Scale aria-hidden="true" />
          <p>{t('app.welcomeIntro')}</p>
        </div>
        <div>
          <Droplets aria-hidden="true" />
          <p>{t('app.welcomeMl')}</p>
        </div>
        <div>
          <FlaskConical aria-hidden="true" />
          <p>{t('app.welcomeGram')}</p>
        </div>
      </div>
      <p className="welcome-note">{t('app.welcomeSchool')}</p>
    </Modal>
  );
}
